import React from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function StudentCount(props) {
  const { project } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="Student count"
      icon={UsersIcon}
      subtitle={project.data.students || '(not provided)'}
      onClick={() => history.push(Urls(project).STUDENT_COUNT)}
    />
  );
};
